import { cachingService, LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { API_HOST_APQ, API_HOST_COMMS, API_HOST_ORGS, API_HOST_REFDATA, API_HOST_SEARCH, API_HOST_SVR, API_HOST_USERS } from "../config";
import { ContactTheRegulatorService } from "./ContactTheRegulatorService";
import { TagsService } from "./TagsService";
import { GeneralConditionsService } from "./GeneralConditionsService";
import { ResourceTagsService } from "./ResourceTagsService";
import { UserService } from "./UserService";
import { CtrCategoryService } from "./ReferenceData";
import ctrStatuses from "./json/ctrStatuses.json";
import { AwardingOrgService } from "./AwardingOrgService";
import { AwardingOrgSearchService } from "./AwardingOrgSearchService";
import { InformationRequestService } from "./InformationRequestService";
import { ApqService } from "./ApqService";

export const contactTheRegulatorService = new ContactTheRegulatorService(API_HOST_COMMS);

export const tagsService = new TagsService(API_HOST_REFDATA);
export const categoriesService = new CtrCategoryService(API_HOST_REFDATA);
export const generalConditionsService = new GeneralConditionsService(API_HOST_REFDATA);
export const resourceTagsService = new ResourceTagsService(API_HOST_SVR);
export const usersService = new UserService(API_HOST_USERS);
export const ctrStatusService = new LocalLookupService(ctrStatuses);
export const aoService = new AwardingOrgService(API_HOST_ORGS);
export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);
export const cachingAoService = cachingService(aoService);
export const informationRequestService = new InformationRequestService(API_HOST_COMMS);
export const apqService = new ApqService(API_HOST_APQ);